import React from 'react';
import { navigate } from 'gatsby';
import ArrowButton from '../../ui/ArrowButton';

const ClaimEstimationLearnMoreButton: React.FC = () => (
  <ArrowButton
    onClick={() =>
      navigate(`${process.env.GATSBY_V2_PREFIX}/blog/category/insurance`)
    }
    mt={700}
    alignSelf="center"
    w={{ base: '100%', tablet: 'auto' }}
  >
    Learn More
  </ArrowButton>
);

export default ClaimEstimationLearnMoreButton;
